/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Autocomplete actions
 */

import { createAction } from 'redux-actions'
import {
  CLEAR_FETCHING_KEY,
  HIDE_MOBILE_AUTOCOMPLETE,
  SET_FETCHING_KEY,
  SET_IS_CURRENT_LOCATION_LOADING,
  SET_IS_FETCHING,
  SET_MOBILE_ORIGIN,
  SHOW_MOBILE_AUTOCOMPLETE,
} from '../constants'

export const clearFetchingKey = createAction(CLEAR_FETCHING_KEY)
export const setFetchingKey = createAction<string, typeof SET_FETCHING_KEY>(SET_FETCHING_KEY)
export const showMobileAutocomplete = createAction(SHOW_MOBILE_AUTOCOMPLETE)
export const hideMobileAutocomplete = createAction(HIDE_MOBILE_AUTOCOMPLETE)
export const setIsCurrentLocationLoading = createAction<
  boolean,
  typeof SET_IS_CURRENT_LOCATION_LOADING
>(SET_IS_CURRENT_LOCATION_LOADING)
export const setMobileOrigin = createAction<string | null, typeof SET_MOBILE_ORIGIN>(
  SET_MOBILE_ORIGIN
)
export const setIsFetching = createAction<boolean, typeof SET_IS_FETCHING>(SET_IS_FETCHING)
